import { Teacher, TeacherAvailability } from '../../types';
import { DayOfWeek } from '../../types';

// Generator functions for teacher mock data

export const generateTeacherId = (index: number): string => {
  return `teacher-${String(index).padStart(3, '0')}`;
};

export const generateTeacherEmail = (firstName: string, lastName: string): string => {
  return `${firstName.toLowerCase()}.${lastName.toLowerCase()}@school.ac.uk`;
};

export const generateTeacherPhone = (): string => {
  return `07${Math.floor(Math.random() * 900000000 + 100000000)}`;
};

export const getContractTypeMaxPeriods = (contractType: 'full-time' | 'part-time' | 'supply'): number => {
  switch (contractType) {
    case 'full-time':
      return 25;
    case 'part-time':
      return 15;
    case 'supply':
      return 10;
  }
};

export const generateFullTimeAvailability = (): TeacherAvailability => {
  return {
    monday: { available: true, periods: [1, 2, 3, 4, 5] },
    tuesday: { available: true, periods: [1, 2, 3, 4, 5] },
    wednesday: { available: true, periods: [1, 2, 3, 4, 5] },
    thursday: { available: true, periods: [1, 2, 3, 4, 5] },
    friday: { available: true, periods: [1, 2, 3, 4, 5] },
  };
};

export const generatePartTimeAvailability = (contractedDays: DayOfWeek[]): TeacherAvailability => {
  const availability: TeacherAvailability = {
    monday: { available: false, periods: [] },
    tuesday: { available: false, periods: [] },
    wednesday: { available: false, periods: [] },
    thursday: { available: false, periods: [] },
    friday: { available: false, periods: [] },
  };

  contractedDays.forEach((day) => {
    availability[day] = { available: true, periods: [1, 2, 3, 4, 5] };
  });

  return availability;
};

export const ukNames = {
  firstNames: [
    'James',
    'Oliver',
    'George',
    'Noah',
    'Arthur',
    'Harry',
    'Leo',
    'Oscar',
    'Charlie',
    'Jack',
    'Emily',
    'Olivia',
    'Amelia',
    'Isla',
    'Ava',
    'Mia',
    'Isabella',
    'Sophia',
    'Grace',
    'Lily',
    'Thomas',
    'William',
    'Henry',
    'Joshua',
    'Daniel',
    'Samuel',
    'Alexander',
    'Benjamin',
    'Lucas',
    'Matthew',
    'Sophie',
    'Charlotte',
    'Ella',
    'Scarlett',
    'Freya',
    'Poppy',
    'Evie',
    'Daisy',
    'Ruby',
    'Jessica',
    'David',
    'Michael',
    'Christopher',
    'Andrew',
    'Paul',
    'Mark',
    'Richard',
    'Simon',
    'Peter',
    'Robert',
    'Sarah',
    'Emma',
    'Laura',
    'Hannah',
    'Rachel',
    'Rebecca',
    'Lucy',
    'Katie',
    'Amy',
    'Jennifer',
  ],
  surnames: [
    'Smith',
    'Jones',
    'Taylor',
    'Brown',
    'Williams',
    'Wilson',
    'Johnson',
    'Davies',
    'Robinson',
    'Wright',
    'Thompson',
    'Evans',
    'Walker',
    'White',
    'Roberts',
    'Green',
    'Hall',
    'Wood',
    'Jackson',
    'Clarke',
    'Patel',
    'Khan',
    'Ahmed',
    'Ali',
    'Hussain',
    'Shah',
    'Begum',
    'Singh',
    'Kaur',
    'Sharma',
    'Murphy',
    "O'Brien",
    'Kelly',
    'Ryan',
    'Walsh',
    'McCarthy',
    "O'Connor",
    "O'Sullivan",
    'Byrne',
    'Martin',
    'Anderson',
    'Campbell',
    'Scott',
    'Mitchell',
    'Young',
    'King',
    'Edwards',
    'Hughes',
    'Lewis',
    'Morris',
  ],
};

export const ukSubjects = [
  'Mathematics',
  'English',
  'Science',
  'Physics',
  'Chemistry',
  'Biology',
  'History',
  'Geography',
  'French',
  'Spanish',
  'German',
  'Art',
  'Music',
  'Drama',
  'PE',
  'ICT',
  'Design Technology',
  'RE',
  'PSHE',
  'Business Studies',
  'Economics',
  'Psychology',
  'Sociology',
];

export const coreSubjects = ['Mathematics', 'English', 'Science'];
export const scienceSubjects = ['Physics', 'Chemistry', 'Biology'];
export const languageSubjects = ['French', 'Spanish', 'German'];
export const humanitiesSubjects = ['History', 'Geography', 'RE', 'PSHE'];
export const artsSubjects = ['Art', 'Music', 'Drama'];

export const staffRoleOptions = ['Teacher', 'HoD', 'HoY', 'SLT', 'Deputy Head', 'Head Teacher'];

export const qualificationTypes = ['PGCE', 'QTS', 'Bachelor of Education', 'Masters in Education', 'NQT', 'RQT'];
